module.exports = __webpack_public_path__ + "static/img/column_recommendation4_1.900006d5.png";